// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"Banner_bannerContainer__IaiQ7","closeIcon":"Banner_closeIcon__97fRJ"};